import React from 'react';
import { Checkbox, makeStyles } from '@material-ui/core';
import { sharedStyles } from './seriesSharedStyles';

const useStyles = makeStyles(theme => {
  const styles = sharedStyles(theme);

  return {
    customCheckboxContainer: styles.customCheckboxContainer,
  };
});

export const SeriesCheckbox = ({ completed, onChange, fontSize, ...rest }) => {
  const classes = useStyles({ fontSize });

  return (
    <Checkbox
      checked={completed}
      onChange={onChange}
      color="primary"
      {...rest}
      icon={
        <div className={classes.customCheckboxContainer}>
          <div />
        </div>
      }
    />
  );
};
